// src/store/firmSettingsStore.ts
import { create } from "zustand";
import api from "../service/api";

interface FirmSettingsStore {
  loading: boolean;
  // Belirli bir firmaya ait ayarları getirir (Süper admin için firmId parametreli)
  fetchSettings: (firmId?: number) => Promise<any>;
  // Ayarları kaydeder (Upsert çalışır)
  saveSettings: (data: any) => Promise<boolean>;
  // Firebase bağlantısını test eder
  testFirebase: (firebaseKey: string) => Promise<{ success: boolean; message: string }>;
  // Manuel havuz tetikleme
  triggerPoolCalculation: (
    firmId?: number,
    month?: number,
    year?: number
  ) => Promise<{ success: boolean; message: string; debugLog?: any; data?: any }>;
}

export const useFirmSettingsStore = create<FirmSettingsStore>((set) => ({
  loading: false,

  fetchSettings: async (firmId?: number) => {
    set({ loading: true });
    try {
      // Backend: GET /firmSettings/my-settings?firmId=...
      const url = firmId ? `/firmSettings/my-settings?firmId=${firmId}` : `/firmSettings/my-settings`;
      const res = await api.get(url);
      set({ loading: false });
      return res.data;
    } catch (err) {
      set({ loading: false });
      return null;
    }
  },

  saveSettings: async (data: any) => {
    set({ loading: true });
    try {
      // Backend'deki create metodu upsert yaptığı için POST kullanıyoruz
      await api.post(`/firmSettings`, data);
      set({ loading: false });
      return true;
    } catch (err) {
      set({ loading: false });
      return false;
    }
  },

  testFirebase: async (firebaseKey: string) => {
    try {
      // Backend: POST /firmSettings/test-firebase
      const res = await api.post("/firmSettings/test-firebase", { firebaseKey });
      return { success: res.data.success, message: res.data.message };
    } catch (err: any) {
      set({ loading: false });
      return { success: false, message: err.response?.data?.message || "Test başarısız." };
    }
  },

  triggerPoolCalculation: async (firmId?: number, month?: number, year?: number) => {
    try {
      const res = await api.post("/discount-pool/trigger-calculation", { firmId, month, year });
      return {
        success: true,
        message: res.data?.message || "Havuz hesaplaması başarıyla tamamlandı.",
        debugLog: res.data?.debugLog,
        data: res.data
      };
    } catch (error: any) {
      console.error("Pool calculation error:", error);
      return {
        success: false,
        message: error.response?.data?.message || "Havuz hesaplanırken hata oluştu.",
        debugLog: null,
        data: null
      };
    }
  }
}));